define('container/initialisers/PartialInitialiser',['underscore'], function (_) {

    'use strict';

    /**
     * Partially applies the loaded module with resolved args
     */
    function PartialInitialiser () {
    }

    PartialInitialiser.prototype.canInitialise = function (extensionApi) {
        return extensionApi.serviceDefinition.init === 'partial';
    };

    PartialInitialiser.prototype.initialise = function (instanceCreatedCallback, Original) {

        var partialArgs = Array.prototype.slice.call(arguments, 2);

        // PartiallyApplied and Original aren't always constructors but the additional
        // modifications needed for constructors don't impact functions afaik
        function PartiallyApplied () {

            var instance = Original.apply(this, partialArgs.concat(_.toArray(arguments)));

            if (instance || this) {
                instanceCreatedCallback(instance || this);
            }

            return instance;

        }

        PartiallyApplied.prototype = Original.prototype;

        try {
            Object.defineProperty(PartiallyApplied, 'name', {
                value: Original.name
            });
        } catch (e) {
            console.warn('Cannot redefine readonly name on Partial')
        }

        return PartiallyApplied;

    };

    return PartialInitialiser;

});

